<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <form v-on:submit.prevent="">
                <div class="row">
                    <div class="col-2">
                        <label class="rdiobox"><input @change="changeCustomerType" v-model="customerType" name="customer-type" value="1" checked type="radio"><span>مشتری حقیقی</span></label>
                    </div>
                    <div class="col-2">
                        <label class="rdiobox"><input @change="changeCustomerType" v-model="customerType" name="customer-type" value="2" type="radio"><span>مشتری حقوقی</span></label>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-3">
                        <form v-on:submit.prevent="searchCustomer">
                            <label for="national-code">کد ملی/شناسه ملی</label>
                            <div class="input-group">
                                <input class="form-control text-left" :maxlength="maxLength" id="national-code" type="tel" v-model="nationalCode">
                                <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                            </div>
                        </form>
                    </div>
                    <div class="col-12 mt-4" v-if="Object.keys(customerDetails).length || Object.keys(legalCustomerDetails).length">
                        <div class="table-responsive">
                            <table class="table table-bordered table-hover user-details-table">
                                <tbody v-if="customerType == 1">
                                    <tr>
                                        <td>نام:</td>
                                        <td>{{ customerDetails.firstName }}</td>
                                        <td>نام خانوادگی:</td>
                                        <td>{{ customerDetails.lastName }}</td>
                                    </tr>
                                    <tr>
                                        <td>شماره همراه:</td>
                                        <td>{{ customerDetails.mobile }}</td>
                                        <td>کد ملی:</td>
                                        <td>{{ customerDetails.nationalCode }}</td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="customerType == 2">
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row mt-3" v-if="customerId && Object.keys(customerDetails).length || Object.keys(legalCustomerDetails).length">
                <div class="col-md-9">
                    <nav class="nav nav-tabs mb-3">
                        <a class="nav-link ml-1 active" data-toggle="tab" @click="setCurrentTab('fizical-card')" href="#fizical-card">کارت هدیه فیزیکی آماده</a>
                        <a class="nav-link" data-toggle="tab" @click="setCurrentTab('fizical-fizical-card')" href="#fizical-fizical-card">کارت هدیه فیزیکی دلخواه</a>
                        <a class="nav-link" data-toggle="tab" @click="setCurrentTab('visual-card')" href="#visual-card">کارت هدیه مجازی</a>
                        <a class="nav-link" data-toggle="tab" @click="setCurrentTab('custom-visual-card')" href="#custom-visual-card">کارت هدیه مجازی دلخواه</a>
                    </nav>
                    <div class="tab-content">
                        <div class="tab-pane active show" id="fizical-card">
                            <FizicalCard v-if="currentTab == 'fizical-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                        <div class="tab-pane" id="visual-card">
                            <VisualCard v-if="currentTab == 'visual-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                        <div class="tab-pane" id="custom-visual-card">
                            <CustomVisualCard v-if="currentTab == 'custom-visual-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                        <div class="tab-pane" id="fizical-fizical-card">
                            <CustomCard v-if="currentTab == 'fizical-fizical-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card custom-card card-body tx-white-8 bg-gray-800">
                        <h6>سبد خرید</h6>
                        <hr class="mb-4 mt-2">
                        <p v-if="!basket.length" class="text-center mb-0">سبد خرید خالی است</p>
                        <div v-else>
                            <div class="row mb-3" v-for="(card,index) in basket" :key="index">
                                <div class="col-md-4 pl-0">
                                    <img :src="!card.imageUrl.includes('base64') ? ('https://cardapi.sabinarya.com' + card.imageUrl) : card.imageUrl" class="w-100">
                                </div>
                                <div class="col-md-5">
                                    <p class="mb-1">{{ card.title }}</p>
                                    <p class="mb-1">تعداد: {{ card.itemsCount }}</p>
                                    <p class="mb-1">مبلغ شارژ: {{ card.deposit ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(card.deposit) : 0 }}</p>
                                </div>
                                <div class="col-md-3">
                                    <button class="btn ripple btn-danger btn-icon float-left" @click="removeCard(index)"><i class="fe fe-minus"></i></button>
                                </div>
                            </div>
                            <div class="form-group mt-3 mb-4">
                                <label>مبلغ تخفیف (ریال)</label>
                                <input type="tel" class="form-control text-center" dir="ltr" @keyup="discountNumberFormat" v-model="discount">
                            </div>
                            <hr class="mt-2 mb-4">
                            <p>مجموع قیمت جسم کارت ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(cardsPrice) }} ریال</p>
                            <p>مجموع قیمت شارژ کارت ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(chargesPrice) }} ریال</p>
                            <p>مبلغ کل (با احتساب تخفیف) : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(displayedTotalPrice) }} ریال</p>
                            <button class="btn btn-success btn-block" @click="submit">تایید و ثبت سفارش</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FizicalCard from './Cards/FizicalCard';
import VisualCard from './Cards/VisualCard';
import CustomCard from './Cards/CustomCard';
import CustomVisualCard from './Cards/CustomVisualCard';
export default {
    name: 'Create',
    components: {FizicalCard,VisualCard,CustomCard,CustomVisualCard},
    data(){
        return {
            customerType: 1,
            nationalCode: '',
            maxLength: 10,
            customerDetails: {},
            legalCustomerDetails: {},
            customerId: 0,
            basket: [],
            currentTab: 'fizical-card',
            discount: 0,
            depositsList: [],
            cardsPrice: 0,
            chargesPrice: 0,
            totalPrice: 0,
            displayedTotalPrice: 0,
            showLoading: false
        }
    },
    watch: {
        discount: function(value){
            let discount = parseInt(value.toString().replace(/,/g,''));
            if(!this.discount)
                this.discount = 0;
            else if(this.totalPrice > discount)
                this.displayedTotalPrice = this.totalPrice - discount;
            else{
                this.discount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.totalPrice);
                this.displayedTotalPrice = 0;
            }
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/Deposits').then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    let deposits = data.result;
                    deposits.sort((a,b) => {
                        return a.depositValue - b.depositValue;
                    })
                    this.depositsList = deposits;
                }
            });
        },
        setCurrentTab(tab){
            this.currentTab = tab;
        },
        addToCard(themeId,title,cardType,itemsCount,price,imageUrl,depositId,optionalCredit = null,metaData = []){
            let finalCount = parseInt(itemsCount);
            this.basket.map(b => finalCount += parseInt(b.itemsCount));
            if(this.customerType == 1 && finalCount > 5){
                this.$swal({
                    title: 'هشدار',
                    icon: 'warning',
                    text: 'تعداد کارت های مشتری حقیقی نمی تواند بیشتر از 5 کارت باشد',
                    confirmButtonText: 'متوجه شدم'
                });
                return false;
            }
            depositId = parseInt(depositId);
            let deposit = 0;
            if(depositId == 61 && optionalCredit){
                optionalCredit = parseInt(optionalCredit.replace(/,/g,''));
                deposit = optionalCredit;
            }else{
                let getDeposit = this.depositsList.filter(deposit => deposit.depositId == depositId)[0];
                if(getDeposit && depositId != 41)
                    deposit = getDeposit.depositValue;
                else
                    deposit = 0;
            }
            if(cardType == 1 || cardType == 2){
                let hasInBasket = this.basket.filter(item => item.themeId == themeId && item.cardType == cardType && item.depositId == depositId && item.optionalCredit == optionalCredit);
                if(hasInBasket.length){
                    let findIndex = this.basket.findIndex(item => item == hasInBasket[0]);
                    this.basket[findIndex].itemsCount = parseInt(this.basket[findIndex].itemsCount) + parseInt(itemsCount);
                }
                else
                    this.basket.push({
                        themeId,
                        title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه مجازی' : 'کارت هدیه دلخواه')),
                        imageUrl,
                        itemsCount: parseInt(itemsCount),
                        price,
                        cardType,
                        depositId,
                        optionalCredit: depositId == 61 ? optionalCredit : 0,
                        deposit,
                        metaData
                    });
            }else
                this.basket.push({
                    themeId,
                    title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه دلخواه' : 'کارت هدیه مجازی')),
                    imageUrl,
                    itemsCount: parseInt(itemsCount),
                    price,
                    cardType,
                    depositId,
                    optionalCredit: depositId == 61 ? optionalCredit : 0,
                    deposit,
                    metaData
                });
            this.calcTotalPrice();
        },
        calcTotalPrice(){
            let totalPrice = 0;
            let depositAmount = 0;
            this.chargesPrice = 0;
            this.cardsPrice = 0;
            let getDeposit;
            this.basket.map(item => {
                depositAmount = 0;
                if(item.depositId && item.depositId != 41){
                    if(item.depositId == 61)
                        depositAmount += (parseInt(item.optionalCredit) * item.itemsCount);
                    else{
                        getDeposit = this.depositsList.filter(deposit => deposit.depositId == item.depositId)[0];
                        depositAmount += (parseInt(getDeposit.depositValue) * item.itemsCount);
                    }
                }
                this.cardsPrice += (item.price * item.itemsCount);
                this.chargesPrice += depositAmount;
                totalPrice += (item.price * item.itemsCount) + depositAmount;
            });
            this.totalPrice = totalPrice;
            let discount = parseInt(this.discount.toString().replace(/,/g,''));
            if(totalPrice > discount)                
                this.displayedTotalPrice = totalPrice - discount;
            else
                this.displayedTotalPrice = 0;
        },
        searchCustomer(){
            
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            const postedData = {
                company: this.customerType == 1 ? false : true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                
                if(data.status){
                    if(this.customerType == 1)
                        this.customerDetails = data.result;
                    else
                        this.legalCustomerDetails = data.result;
                    this.setCurrentTab('fizical-card');
                }
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).catch(() => {
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'کاربری در سیستم یافت نشد'
                });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        removeCard(itemIndex){
            let basket = this.basket.filter((item,index) => index != itemIndex);
            this.basket = basket;
            this.calcTotalPrice();
        },
        discountNumberFormat(){
            let value = this.discount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.discount = value;
        },
        changeCustomerType(){
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            this.maxLength = this.customerType == 1 ? 10 : 11;
            this.nationalCode = '';
            this.basket = [];
        },
        submit(){
            this.$swal({
                icon: 'warning',
                title: 'توجه !',
                text: 'آیا از ثبت سفارش اطمینان دارید ؟',
                confirmButtonText: 'ثبت سفارش',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then((result) => {
                if(result.isConfirmed){
                    this.showLoading = true;
                    const postedData = {
                        items: this.basket,
                        discount: parseInt(this.discount.toString().replace(/,/g,'')),
                        customerId: this.customerId
                    };
                    this.$api.post('Management/Group/Sell',postedData).then(({data}) => {
                        if(data.status)
                            this.$swal({
                                icon: 'success',
                                title: 'تبریک !',
                                text: 'ثبت سفارش با موفقیت انجام شد',
                            }).then(res => {
                                if(res.isConfirmed){
                                    this.$router.push({name: 'orders.show',params: {id: data.result.orderId}});
                                }
                            });
                    }).catch(({response}) => {
                        let html = '';
                        response.data.errors.map(err => html += err.message + '<br>');
                        this.$swal({
                            icon: 'error',
                            title: 'خطا !',
                            html
                        });
                    }).finally(() => {
                        this.showLoading = false;
                    });
                }else
                    this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>
